
import React, { Component } from 'react';
import request from 'request-promise-native';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import config from '../../config/config';
import { getAnonymousURL, getAuthHeader } from '../../utils/service-utils';
import { types, INITIAL_STATE } from './constants';
import reducer from './BundleDetailsReducer';
import BundleDetailsWrapper from './BundleDetailsWrapper';

export class BundleDetailsContainerInner extends Component {
	constructor(props) {
		super(props);
		this.mounted = false;
		this.state = { ...INITIAL_STATE };
		this.bundleDetailsTimeout = null;
	}

	componentDidMount() {
		this.mounted = true;
		this.bundleDetailsTimeout = setTimeout(() => {
			this.getBundleDetails(this.props.match.params.id);
		}, 300);
	}

	componentDidUpdate(prevProps) {
		const {
			auth: { loginPending }
		} = this.props;

		const prevLoginPending = prevProps?.auth?.loginPending;
		if (prevLoginPending && !loginPending) {
			// Auth state stabilized; re-fetch to ensure correct anonymous/auth view.
			this.getBundleDetails(this.props.match.params.id);
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.bundleDetailsTimeout) {
			clearTimeout(this.bundleDetailsTimeout);
		}
	}

	dispatch = action => {
		if (this.mounted) {
			this.setState(prevState => reducer(prevState, action));
		}
	};

	thunk = (options, actions, args = {}, callback) => {
		this.dispatch({ type: actions[0], args });
		request({ ...options, json: true })
			.then(response => {
				this.dispatch({ type: actions[1], response, args });
				if (callback) callback(undefined, response);
			})
			.catch(error => {
				const response = error?.error;
				const normalizedError = response || error;
				this.dispatch({ type: actions[2], error: normalizedError, args });
				if (callback) callback(normalizedError);
			});
	};

	getBundleDetails = bundleId => {
		const apiGatewayUrl = getAnonymousURL(
			this.props.auth,
			config.api.apiGatewayUrlV2
		);

		const options = {
			method: 'GET',
			url: `${apiGatewayUrl}/directory/bundles/${bundleId}`,
			headers: { ...getAuthHeader(this.props.auth) }
		};

		this.thunk(options, [
			types.BUNDLE_DETAILS_GET_REQUEST,
			types.BUNDLE_DETAILS_GET_RECEIVE,
			types.BUNDLE_DETAILS_GET_ERROR
		]);
	};

	fetchApiSpecInBundle = ({ apiId, apiType } = {}) => {
		const apiGatewayUrl = getAnonymousURL(
			this.props.auth,
			config.api.apiGatewayUrlV2
		);
		const bundleId = this.props.match.params.id;
		const url = `${apiGatewayUrl}/directory/bundles/${bundleId}?apiId=${apiId}&apiType=${apiType}`;

		const options = {
			method: 'GET',
			url,
			headers: { ...getAuthHeader(this.props.auth) }
		};

		return new Promise((resolve, reject) => {
			this.thunk(
				options,
				[
					types.API_SPEC_IN_BUNDLE_GET_REQUEST,
					types.API_SPEC_IN_BUNDLE_GET_RECEIVE,
					types.API_SPEC_IN_BUNDLE_GET_ERROR
				],
				{ apiId, apiType, isAuthenticated: this.props.auth.isAuthenticated },
				(err, response) => {
					if (err) reject(err);
					else resolve(response);
				}
			);
		});
	};

	render() {
		return (
			<BundleDetailsWrapper
				store={this.state}
				dispatch={this.dispatch}
				fetchApiSpecInBundle={this.fetchApiSpecInBundle}
				{...this.props}
			/>
		);
	}
}

function withContainer(WrappedComponent) {
	return withEntityContext(BundleDetailsContainerInner);
}

export default withAuth(withContainer(BundleDetailsContainerInner));

